import type { Activity, ImAccount } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export interface ImAccountDetails extends ImAccount {
    positionsDetails: Array<{
        name: string;
        assetId: string;
        symbol: string;
        description: string;
    }>;
    activities?: Activity[];
}

export const useGetApexAccountDetails = (accountId: string) => {
    return useGetAccountDetails({
        accountId,
    });
};

export const useGetExpandedApexAccountDetails = (accountId: string) => {
    return useGetExpandedAccountDetails({
        accountId,
    });
};

const useGetAccountDetails = requestBuilder.query<
    ImAccount | null,
    { accountId: string }
>({
    endpoint: ({ accountId }) =>
        `/api/investments/${accountId}/details?expanded=false`,
    queryKey: ({ accountId }) =>
        `/investments/account/${accountId}/details?expanded=false`,
});

const useGetExpandedAccountDetails = requestBuilder.query<
    ImAccountDetails | null,
    { accountId: string }
>({
    endpoint: ({ accountId }) =>
        `/api/investments/${accountId}/details?expanded=true`,
    queryKey: ({ accountId }) =>
        `/investments/account/${accountId}/details?expanded=true`,
});
